<!--<scitis-app-global-page-header [pageTitle]="'Machine Categories'">-->
<!--</scitis-app-global-page-header>-->

<!-- Submenu when more "portal setup" features are available
<div class="row">
  <div class="col-12 col-lg-auto mb-3 mb-lg-0">
    <div class="card nav-vertical">
      <div class="card-header">
        <em class="fa-solid fa-bars"></em>
        <span translate>Configuration</span>
      </div>
      <ul [(activeId)]="show" ngbNav orientation="vertical">
        <li [disabled]="isDisabledPlaceholder" ngbNavItem="machine_categories">
          <a (click)="onMenuClick(menuItems.MACHINE_CATEGORIES)" ngbNavLink translate>Machine categories</a>
        </li>
        <li [disabled]="isDisabledPlaceholder" ngbNavItem="placeholder">
          <a (click)="onMenuClick(menuItems.PLACEHOLDER)" ngbNavLink translate>Placeholder</a>
        </li>
      </ul>
    </div>
  </div>

  <div class="col-12 col-lg">
    <div class="tab-container">

      <scitis-portal-setup-machine-categories
          *ngIf="show === menuItems.MACHINE_CATEGORIES">
      </scitis-portal-setup-machine-categories>


    </div>
  </div>




  </div>
-->

<scitis-portal-setup-machine-categories></scitis-portal-setup-machine-categories>